// @ai-generated 2026-08-05T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
// Card styling is uniform (white background, subtle border) — the accent is a colored left
// border stripe plus a colored icon in the header. Keeps nested trees readable when many
// combinators stack up.
export const CARD_BASE_CLASSES =
    'rounded-md border border-(--mantine-color-outline-5) bg-(--mantine-color-secondary-0) shadow-sm border-l-4';

export const ACCENT = {
    and: { border: 'border-l-(--mantine-color-text-3)', icon: 'text-(--mantine-color-secondary-9)' },
    or: { border: 'border-l-(--mantine-color-info-4)', icon: 'text-(--mantine-color-info-6)' },
    for_each: { border: 'border-l-(--mantine-color-success-6)', icon: 'text-(--mantine-color-success-7)' },
    // No `filtered` entry: FilteredRenderer owns its accent in FilteredRenderer.module.css, which is
    // where new renderers should put it. This map stays for the renderers still on Tailwind.
    ruleset_ref: { border: 'border-l-(--mantine-color-accent-4)', icon: 'text-(--mantine-color-accent-6)' },
    if_then_else: { border: 'border-l-(--mantine-color-warning-5)', icon: 'text-(--mantine-color-warning-7)' },
} as const;
